import request from '@/router/axios'

export const getDwellplotList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/dwellplot/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const removeDwellplot = ids => request({
  url: '/api/mcc-worker/dwellplot/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const addDwellplot = params => request({
  url: '/api/mcc-worker/dwellplot/save',
  method: 'post',
  data: params,
})

export const addBlock = params => request({
  url: '/api/mcc-worker/dwellbuilding/save',
  method: 'post',
  data: params,
})

export const removeBlock = ids => request({
  url: '/api/mcc-worker/dwellbuilding/remove',
  method: 'post',
  params: {
    ids,
  },
})

export const downLoadBlkExcel = () => request({
  url: '/api/mcc-worker/dwellbuilding/blkExcel',
  method: 'get',
  responseType: 'blob',
})

export const uploadBlkExcel = (filename, file) => {
  const formData = new FormData()
  formData.append(filename, file)
  return request({
    url: '/api/mcc-worker/dwellbuilding/blkExcel2',
    method: 'post',
    data: formData,
  })
}

export const updateDwellplot = params => request({
  url: '/api/mcc-worker/dwellplot/update',
  method: 'post',
  data: params,
})

export const updateBlock = params => request({
  url: '/api/mcc-worker/dwellbuilding/update',
  method: 'post',
  data: params,
})

export const getBlockList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/dwellbuilding/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const getBlockWorkerList = (current, size, params) => request({
  url: '/api/mcc-worker/dwellroomref/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

export default {
  getDwellplotList,
}
